export default "__VITE_ASSET__Ng3aXJ5M__"